.ambient {
  position: absolute;
  inset: -8%;
  width: 116%;
  height: 116%;
  z-index: 0;
  filter: blur(48px) saturate(1.4);
  opacity: 0.55;
  pointer-events: none;
  object-fit: cover;
}
